import Vue from 'vue'

export function canViewIndex () {
  return Vue.prototype.can('viewIndex')
}

export function canViewEq () {
  return Vue.prototype.can('viewEquipment')
}

export function canViewUser () {
  return Vue.prototype.can('view_UserModel')
}
